import React from 'react';

import { TableContext } from './TableContext';

export type TableProviderProps = {
  children: React.ReactNode;
  shouldVirtualize: boolean;
};

export function TableProvider({ children, shouldVirtualize }: TableProviderProps) {
  const contextValue = React.useMemo(
    () => ({
      shouldVirtualize,
    }),
    [shouldVirtualize],
  );

  return <TableContext.Provider value={contextValue}>{children}</TableContext.Provider>;
}
